var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{class:_vm.isMobileSize() ? 'ma-0 pa-0' : null},[_c('v-row',[_c('v-col',[_c('Store')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }